import { getRequest } from '@/core';
import { tripTypes } from '@/requests';

export default async function getTripTypesRequest() {
	let url = tripTypes.getPath();
	try {
		let response = await getRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}